/*
 * @Author: Mufaddal Jamali
 * @Date: 2020-02-24 15:49:21
 * @Last Modified by: Mufaddal Jamali
 * @Last Modified time: 2021-01-28 18:35:14
 */
import React, { Component } from "react";
import ModalHead from "../components/modal-head/modalHead";
import { Steps } from "antd";
import DeviceDetails from "./deviceDetails";
import ServiceDetails from "./serviceDetails";
import Slots from "./slots";
import UserDetails from "./userDetails";
import SecondaryButton from "../components/utils/secondaryButton";
import PrimaryButton from "../components/utils/primaryButton";
import ConfirmedAppointment from "./confirmedAppointment";
import { Empty } from "antd";
import { DataService } from "../services/data.service";
import { withRouter } from "react-router-dom";
import swal from "sweetalert";
import moment from "moment";

import Footer from "../components/footer/footer";
import AppNotFound from "./../components/app-not-found/notFound";
import CategorySelection from "./categorySelection";
import BranchSelection from "./branchSelection";

import Loader from "../components/loader/loader";
import * as handler from "../components/utils/handler";
import SlotModal from "../components/slot-modal/slotModal";
import DeviceService from "./DeviceService";
import UpdateAppointment from "./updateAppointment";

const queryString = require("query-string");

const { Step } = Steps;
const slotmodals = new SlotModal();
class Main extends Component {
  defaultCategory = window["app-config"].defaultCategory;
  enableCategorySelection = window["app-config"].enableCategorySelection;
  issueTicketEnabled = window["app-config"].issueTicketEnabled;
  runApp = window["app-config"].runApp;
  showFooter = window["app-config"].ui.footer.showFooter;
  defaultLanguage = window["app-config"].defaultLang;

  nextAndBackBtnColor = window["app-config"].ui.nextAndBackBtn.backgroundColor;
  isAdditionalValidation = window["app-config"].isAdditionalValidation;
  ticketIssuePassword = window["app-config"].ticketIssuePassword;
  priority = window["app-config"].priority;

  dataService = new DataService();

  state = {
    lang: {},
    current: 0,
    showNextBtn: true,
    showBackBtn: true,

    categoryId: null,
    deviceHealth: null,
    phoneServiceName: null,

    model: null,
    color: null,
    productType: null,
    productFamily: null,
    imei: null,

    firstName: null,
    surName: null,
    emailAddress: null,
    phoneNumber: null,
    additionalInfo: null,
    noOfPeople: null,
    documentType: null,
    isTermsConditonsChecked: false,
    isAssistanceChecked: false,

    date: null,
    time: null,
    slotId: null,

    response: null,

    singleBranchDetails: [],
    isBranchPage: false,
    selectedBranchFromMap: null,

    dataLoaded: true,

    heading: null,

    isConfirmedReschedule: false,

    issueTicket: false, //from branch map
    issueQrTicket: false,
    isSingleBranchDetailsLoaded: false,
  };
  steps = [];

  constructor(props) {
    super();
    if (this.runApp.toLowerCase() === "samsung") {
      this.steps = [
        {
          title: this.state.lang.DeviceService,
          content: (
            <DeviceService
              deviceDetails={this.getDeviceDetailsFromChild}
              hideBtnNext={this.hideBtnNext}
              setHeading={this.setHeading}
              serviceDetails={this.getServiceDetailsFromChild}
              // branchDetails={this.sendBranchDetails}
              showBtnNext={this.showBtnNext}
              isSingleBranchDetailsLoaded={
                this.state.isSingleBranchDetailsLoaded
              }
            />
          ),
        },

        {
          title: this.state.lang.StepSlots,
          content: (
            <Slots
              dateTimeSlot={this.getDateTimeSlotFromChild}
              time={this.state.time}
              hideBtnNext={this.hideBtnNext}
              setHeading={this.setHeading}
              branchDetails={this.sendBranchDetails}
              category={this.sendCategory}
            />
          ),
        },
        {
          title: this.state.lang.StepCustomerDetails,
          content: (
            <UserDetails
              userDetails={this.getUserDetailsFromChild}
              hideBtnNext={this.hideBtnNext}
              setHeading={this.setHeading}
              mainState={this.sendMainState}
              showBtnNext={this.showBtnNext}
            />
          ),
        },
        {
          title: this.state.lang.StepComplete,
          content: (
            <ConfirmedAppointment
              getData={this.sendMainState}
              hideBtnBack={this.hideBtnBack}
              setHeading={this.setHeading}
              getStepCount={this.getStepCount}
            />
          ),
        },
      ];
    } else if (this.enableCategorySelection === false) {
      this.steps = [
        {
          content: (
            <BranchSelection
              hideBtnNext={this.hideBtnNext}
              setHeading={this.setHeading}
              setSelectedBranch={this.setSelectedBranchFromMap}
              branchDetails={this.sendBranchDetails}
              getStepCount={this.getStepForBranch}
            />
          ),
        },
        {
          content: (
            <Slots
              dateTimeSlot={this.getDateTimeSlotFromChild}
              time={this.state.time}
              hideBtnNext={this.hideBtnNext}
              setHeading={this.setHeading}
              branchDetails={this.sendBranchDetails}
              category={this.sendCategory}
            />
          ),
        },
        {
          content: (
            <UserDetails
              userDetails={this.getUserDetailsFromChild}
              hideBtnNext={this.hideBtnNext}
              setHeading={this.setHeading}
              mainState={this.sendMainState}
              branchDetails={this.sendBranchDetails}
              showBtnNext={this.showBtnNext}
            />
          ),
        },
        {
          content: (
            <ConfirmedAppointment
              getData={this.sendMainState}
              hideBtnBack={this.hideBtnBack}
              setHeading={this.setHeading}
              getStepCount={this.getStepCount}
            />
          ),
        },
      ];
    } else if (this.enableCategorySelection === true) {
      this.steps = [
        {
          content: (
            <BranchSelection
              hideBtnNext={this.hideBtnNext}
              setHeading={this.setHeading}
              setSelectedBranch={this.setSelectedBranchFromMap}
              branchDetails={this.sendBranchDetails}
              getStepCount={this.getStepForBranch}
            />
          ),
        },
        {
          content: (
            <CategorySelection
              categoryDetails={this.getCategorySelectionFromChild}
              hideBtnNext={this.hideBtnNext}
              branchDetails={this.sendBranchDetails}
              mainState={this.sendMainState}
            />
          ),
        },
        {
          content: (
            <Slots
              dateTimeSlot={this.getDateTimeSlotFromChild}
              time={this.state.time}
              hideBtnNext={this.hideBtnNext}
              setHeading={this.setHeading}
              branchDetails={this.sendBranchDetails}
              category={this.sendCategory}
            />
          ),
        },
        {
          content: (
            <UserDetails
              userDetails={this.getUserDetailsFromChild}
              hideBtnNext={this.hideBtnNext}
              setHeading={this.setHeading}
              mainState={this.sendMainState}
              branchDetails={this.sendBranchDetails}
              showBtnNext={this.showBtnNext}
            />
          ),
        },
        {
          content: (
            <ConfirmedAppointment
              getData={this.sendMainState}
              hideBtnBack={this.hideBtnBack}
              setHeading={this.setHeading}
              getStepCount={this.getStepCount}
            />
          ),
        },
      ];
    }
  }

  queryStringBranchCode = queryString.parse(window.location.search);
  queryBranchCode = this.queryStringBranchCode.branchCode;

  queryissueTicketFlag = queryString.parse(window.location.search);
  issueTicketFlag = this.queryissueTicketFlag.issueticket;

  queryStringSQN = queryString.parse(window.location.search);
  querySQN = this.queryStringSQN.sqn;

  queryStringBranchId = queryString.parse(window.location.search);
  queryBranchId = this.queryStringBranchId.branchid;

  componentDidMount() {
    this.setState({ lang: handler.setTranslations() });
    if (
      localStorage.getItem("confirmed") === "true" &&
      (JSON.parse(localStorage.getItem("prevState")).issueTicket == true ||
        JSON.parse(localStorage.getItem("prevState")).issueQrTicket == true)
    ) {
      if (
        moment().toDate().toDateString() ===
        localStorage.getItem("confirmedDate")
      ) {
        let prevState = JSON.parse(localStorage.getItem("prevState"));
        this.setState(prevState);
      } else {
        localStorage.removeItem("confirmedDate");
        localStorage.removeItem("prevState");
        localStorage.removeItem("confirmed");

        this.getSingleBranchDetails();
        if (this.enableCategorySelection === false) {
          this.setState({ categoryId: this.defaultCategory });
        }
        this.getStepCount();
        this.getStepForBranch();
      }
    } else {
      this.getSingleBranchDetails();
      if (this.enableCategorySelection === false) {
        this.setState({ categoryId: this.defaultCategory });
      }
      this.getStepCount();
      this.getStepForBranch();
    }
  }

  getSingleBranchDetails = async () => {
    try {
      let singleBranchDetails = await this.dataService.getSingleBranchDetails();

      this.setState({
        singleBranchDetails:
          singleBranchDetails === "" ? [] : singleBranchDetails.data.branchList,
        isSingleBranchDetailsLoaded: true,
      });

      this.stepJump();
    } catch (error) {
      this.setState({
        singleBranchDetails: [],
        isSingleBranchDetailsLoaded: false,
      });
      console.log("CATCH OF SINGLE BRANCH API", this.state.singleBranchDetails);
    }
  };

  stepJump = () => {
    let current;

    //Condition for jump to user details screen when there are branchId and SQN provided in query string for issue ticket
    if (
      this.queryBranchCode != undefined &&
      this.querySQN != undefined &&
      this.queryBranchCode != "" &&
      this.querySQN != "" &&
      this.queryBranchId !== undefined &&
      this.queryBranchId !== "" &&
      this.enableCategorySelection === true &&
      this.issueTicketEnabled === true
    ) {
      current = this.state.current + 3;
      this.setState({
        current,
        issueQrTicket: true,
        categoryId: this.querySQN,
      });
    } else if (
      this.queryBranchCode != undefined &&
      this.querySQN != undefined &&
      this.queryBranchCode != "" &&
      this.querySQN != "" &&
      this.queryBranchId !== undefined &&
      this.queryBranchId !== "" &&
      this.enableCategorySelection === false &&
      this.issueTicketEnabled === true
    ) {
      current = this.state.current + 2;
      this.setState({
        current,
        issueQrTicket: true,
        categoryId: this.querySQN,
      });
    } else if (
      this.queryBranchCode !== undefined &&
      this.queryBranchCode !== "" &&
      this.issueTicketFlag !== undefined &&
      this.enableCategorySelection === true &&
      this.issueTicketFlag.toLowerCase() === "true" &&
      this.runApp.toLowerCase() !== "samsung"
    ) {
      current = this.state.current + 1;
      this.setState({
        current,
        issueTicket: true,
      });
    } else if (
      this.queryBranchCode !== undefined &&
      this.queryBranchCode !== "" &&
      this.issueTicketFlag !== undefined &&
      this.issueTicketFlag.toLowerCase() === "true" &&
      this.enableCategorySelection === false &&
      this.runApp.toLowerCase() !== "samsung"
    ) {
      current = this.state.current + 2;
      this.setState({
        current,
        issueTicket: true,
      });
    } else if (
      this.queryBranchCode !== undefined &&
      this.runApp.toLowerCase() !== "samsung"
    ) {
      current = this.state.current + 1;
      this.setState({ current });
    }
  };

  sendMainState = () => {
    return this.state;
  };

  hideBtnNext = () => {
    this.setState({ showNextBtn: false });
  };

  showBtnNext = () => {
    this.setState({ showNextBtn: true });
  };

  hideBtnBack = () => {
    this.setState({ showBackBtn: false });
  };

  getServiceDetailsFromChild = (data) => {
    debugger;
    this.setState({
      categoryId: data.categoryId,
      deviceHealth: data.deviceHealth,
      phoneServiceName: data.phoneServiceName,
      symptomDetailName: data.symptomDetailName,
      imei: data.imei,
    });
    console.log(this.state);
  };

  getDeviceDetailsFromChild = (data) => {
    debugger;
    this.setState({
      model: data.model,
      color: data.color,
      productType: data.productType,
      productFamily: data.productFamily,
      // imei: data.imei,
      showNextBtn:
        data.model !== null &&
        data.color !== null &&
        data.productType !== null &&
        data.productFamily !== null
          ? true
          : false,
    });
  };

  getUserDetailsFromChild = (data) => {
    this.setState({
      firstName: data.firstName,
      surName: data.surName,
      emailAddress: data.emailAddress,
      phoneNumber: data.phoneNumber,
      isUserDetailCmp: data.isUserDetailCmp,
      additionalInfo: data.additionalInfo,
      noOfPeople: data.noOfPeople,
      documentType: data.documentType,

      isTermsConditonsChecked: data.isTermsConditonsChecked,
      isAssistanceChecked: data.isAssistanceChecked,
      showNextBtn: true,
    });
  };

  getDateTimeSlotFromChild = (slotId, date, time) => {
    slotmodals.saveSlot(time);
    this.setState({
      slotId: slotId,
      date: date,
      time: time,
      showNextBtn: time !== null && date !== null ? true : false,
    });
  };

  getCategorySelectionFromChild = (data) => {
    this.setState({
      categoryId: data.categoryId,
      showNextBtn: data.categoryId !== null ? true : false,
    });
  };

  setHeading = (heading) => {
    this.setState({ heading: heading });
  };

  setSelectedBranchFromMap = (branch) => {
    this.setState({ selectedBranchFromMap: branch });
  };

  sendBranchDetails = () => {
    if (this.state.singleBranchDetails.length > 0) {
      return this.state.singleBranchDetails;
    } else {
      return [this.state.selectedBranchFromMap];
    }
  };

  sendCategory = () => {
    return this.state.categoryId;
  };

  getStepCount = (current, isConfirmedReschedule, dataLoaded) => {
    if (current !== undefined || isConfirmedReschedule !== undefined) {
      this.setState({ current, isConfirmedReschedule, dataLoaded: dataLoaded });
    }
  };

  getStepForBranch = (current, isBranchPage, issueTicket) => {
    if (
      current !== undefined ||
      isBranchPage !== undefined ||
      issueTicket !== undefined
    ) {
      this.setState({ current, isBranchPage, issueTicket });
    }
  };

  rescheduleAppointment = async () => {
    try {
      let response = await this.dataService.rescheduleAppointment(
        this.state.response.data.previous_appointment_info === null
          ? this.state.response.data.issueAppointment.appointment_number
          : this.state.response.data.previous_appointment_info
              .appointment_number,
        this.state.response.data.previous_appointment_info === null
          ? this.state.categoryId
          : this.state.response.data.previous_appointment_info.category_id,
        this.state.categoryId,
        this.state.singleBranchDetails.length > 0
          ? this.state.singleBranchDetails[0].BranchID
          : this.state.selectedBranchFromMap.BranchID,
        this.state.singleBranchDetails.length > 0
          ? this.state.singleBranchDetails[0].BranchTitle
          : this.state.selectedBranchFromMap.BranchTitle,
        this.state.singleBranchDetails.length > 0
          ? this.state.singleBranchDetails[0].Address
          : this.state.selectedBranchFromMap.Address,
        this.state.singleBranchDetails.length > 0
          ? this.state.singleBranchDetails[0].ContactNo
          : this.state.selectedBranchFromMap.ContactNo,

        this.state.slotId,
        2,
        moment(this.state.date, "DD-MMM-YYYY").format("YYYY-MM-DD"),
        this.state.emailAddress,
        1,
        0,

        [
          {
            fieldName: "EmailId",
            fieldValue:
              this.state.emailAddress != undefined
                ? this.state.emailAddress
                : this.state.phoneNumber !== undefined
                ? this.state.phoneNumber
                : "",
          },
          {
            fieldName: "MobileNumber",
            fieldValue:
              this.state.phoneNumber != undefined ? this.state.phoneNumber : "",
          },
          { fieldName: "PhoneModel", fieldValue: "-" },
          { fieldName: "PhoneColor", fieldValue: "-" },
          {
            fieldName: "PhoneService",
            fieldValue: "-",
          },
          { fieldName: "IMEINumber", fieldValue: "-" },
          {
            fieldName: "DeviceHealth",

            fieldValue: `${
              this.state.documentType !== null
                ? this.state.documentType + "-"
                : ""
            }${
              this.state.additionalInfo !== undefined
                ? this.state.additionalInfo
                : ""
            } `,
          },
          {
            fieldName: "FirstName",
            fieldValue:
              this.state.firstName != undefined ? this.state.firstName : "",
          },
          {
            fieldName: "Surname",
            fieldValue:
              this.state.surName != undefined ? this.state.surName : "",
          },

          {
            fieldName: "AppUrl",
            fieldValue: `${
              handler.urls.MODIFY_APPOINTMENT
            }${localStorage.getItem("lang")}`,
          },
        ],
        localStorage.getItem("lang") === "es"
          ? "Sp"
          : localStorage.getItem("lang"),
        this.state.time
      );
      console.log("RESCHEDULE RESPONSE", response);
      if (response.data.error !== undefined && response.data.error === true) {
        handler.showErrorMessage(
          this.state.lang.Error,
          this.state.lang.SomeThingWentWrong,
          this.state.lang.Ok
        );
      } else {
        if (response.data.issueAppointment.resp_message === "success") {
          const current = this.state.current + 1;
          this.setState({
            current,
            response: response,
          });
        } else if (
          response.data.issueAppointment.resp_message ===
          "Appointment quota for this time slot has reached to its maximum value. Try selecting different time slot."
        ) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.TimeSlotQuotaExceed,
            this.state.lang.Ok
          );
        } else if (response.data.issueAppointment.resp_status === 6) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.AppointmentAlreadyCanceled,
            this.state.lang.Ok
          );
        } else if (response.data.issueAppointment.resp_status === 7) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.AppointmentExpired,
            this.state.lang.Ok
          );
        } else if (response.data.issueAppointment.resp_status === 3) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.CantRescheduleApptTcktIssued,
            this.state.lang.Ok
          );
        } else if (response.data.issueAppointment.resp_status === -2) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.AlreadyServed,
            this.state.lang.Ok
          );
        } else if (response.data.issueAppointment.resp_status === -3) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.ApptCanceledAutomatically,
            this.state.lang.Ok
          );
        } else if (response.data.issueAppointment.resp_status === -6) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.YouAlreadyHaveAnAppointment,
            this.state.lang.Ok
          );
        } else {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.SomeThingWentWrong,
            this.state.lang.Ok
          );
        }
      }
    } catch (error) {
      if (error.message.includes("timeout")) {
        handler.showErrorMessage(
          this.state.lang.Error,
          this.state.lang.ServerNotResponding,
          this.state.lang.Ok
        );
      } else {
        handler.showErrorMessage(
          this.state.lang.Error,
          this.state.lang.SomeThingWentWrong,

          this.state.lang.Ok
        );
      }

      console.log("ERROR IN RESCHEDULE APPOINTMENT: ".error.message);
    }
  };

  issueAppointment = async () => {
    try {
      var response = await this.dataService.issueAppointment(
        this.state.categoryId,

        this.state.singleBranchDetails.length > 0
          ? this.state.singleBranchDetails[0].BranchID
          : this.state.selectedBranchFromMap.BranchID,
        this.state.singleBranchDetails.length > 0
          ? this.state.singleBranchDetails[0].BranchTitle
          : this.state.selectedBranchFromMap.BranchTitle,
        this.state.singleBranchDetails.length > 0
          ? this.state.singleBranchDetails[0].Address
          : this.state.selectedBranchFromMap.Address,
        this.state.singleBranchDetails.length > 0
          ? this.state.singleBranchDetails[0].ContactNo
          : this.state.selectedBranchFromMap.ContactNo,
        this.state.slotId,

        2,
        moment(this.state.date, "DD-MMM-YYYY").format("YYYY-MM-DD"),

        this.state.emailAddress,
        1,
        0,

        [
          {
            fieldName: "EmailId",
            fieldValue:
              this.state.emailAddress != undefined
                ? this.state.emailAddress
                : this.state.phoneNumber !== undefined
                ? this.state.phoneNumber
                : "",
          },
          {
            fieldName: "MobileNumber",
            fieldValue:
              this.state.phoneNumber != undefined ? this.state.phoneNumber : "",
          },
          { fieldName: "PhoneModel", fieldValue: "-" },
          { fieldName: "PhoneColor", fieldValue: "-" },
          {
            fieldName: "PhoneService",
            fieldValue: "-",
          },
          { fieldName: "IMEINumber", fieldValue: "-" },
          {
            fieldName: "DeviceHealth",
            fieldValue: `${
              this.state.documentType !== null
                ? this.state.documentType + "-"
                : ""
            }${
              this.state.additionalInfo !== undefined
                ? this.state.additionalInfo
                : ""
            } `,
          },
          {
            fieldName: "FirstName",
            fieldValue:
              this.state.firstName != undefined ? this.state.firstName : "",
          },
          {
            fieldName: "Surname",
            fieldValue:
              this.state.surName === undefined ? "" : this.state.surName,
          },

          {
            fieldName: "AppUrl",
            fieldValue: `${
              handler.urls.MODIFY_APPOINTMENT
            }${localStorage.getItem("lang")}`,
          },
        ],
        localStorage.getItem("lang") === "es"
          ? "Sp"
          : localStorage.getItem("lang"),
        this.state.time
      );

      if (response.data.error !== undefined && response.data.error === true) {
        handler.showErrorMessage(
          this.state.lang.Error,
          this.state.lang.ServerNotResponding,
          this.state.lang.Ok
        );
      } else {
        this.setState({ response: response, dataLoaded: true });
        if (response.data.issueAppointment.resp_status === -6) {
          swal(
            this.state.lang.AppointmentAlreadyExists,
            this.state.lang.YouAlreadyHaveAnAppointment,

            {
              icon: "warning",
              buttons: {
                keepPreviousOne: {
                  text: this.state.lang.KeepPrevious,
                  value: "keepPreviousOne",
                },
                reschedule: {
                  text: this.state.lang.Reschedule,
                  value: "reschedule",
                  closeModal: false,
                },
              },
            }
          ).then(async (value) => {
            var current;

            switch (value) {
              case "keepPreviousOne":
                if (
                  this.state.response.data.previous_appointment_info != null
                ) {
                  let prevResponse =
                    this.state.response.data.previous_appointment_info;

                  current = this.state.current + 1;
                  console.log("PREV RESPONSE:", prevResponse);
                  this.setState({
                    categoryId: prevResponse.category_id,
                    current,
                  });
                }
                break;

              case "reschedule":
                this.rescheduleAppointment();
                swal.close();

                break;

              default:
            }
          });
        } else if (response.data.issueAppointment.resp_status === 1) {
          const current = this.state.current + 1;
          this.setState({ current, response: response });
          console.log("ISSUE APPT RESPONSE: ", response);
        } else if (
          response.data.issueAppointment.resp_message ===
          "Appointment quota for this time slot has reached to its maximum value. Try selecting different time slot."
        ) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.TimeSlotQuotaExceed,
            this.state.lang.Ok
          );
        } else {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.SomeThingWentWrong,
            this.state.lang.Ok
          );
        }
      }
    } catch (error) {
      if (error.message.includes("timeout")) {
        handler.showErrorMessage(
          this.state.lang.Error,
          this.state.lang.ServerNotResponding,
          this.state.lang.Ok
        );
      } else {
        handler.showErrorMessage(
          this.state.lang.Error,
          this.state.lang.SomeThingWentWrong,
          this.state.lang.Ok
        );
      }
    }
  };

  issueTicket = async () => {
    try {
      let phoneNumber =
        this.state.phoneNumber != undefined
          ? this.state.phoneNumber.replace("+", "%2b")
          : "";
      let issueTicketResponse = await this.dataService.issueTicket(
        this.state.singleBranchDetails.length > 0
          ? this.state.singleBranchDetails[0].BranchID
          : this.state.selectedBranchFromMap.BranchID,

        this.state.categoryId,

        0,
        this.state.emailAddress != undefined
          ? this.state.emailAddress
          : phoneNumber,
        3,
        localStorage.getItem("lang") === "es"
          ? "Sp"
          : localStorage.getItem("lang"),
        `${this.state.firstName === undefined ? "" : this.state.firstName}%20${
          this.state.surName === undefined ? "" : this.state.surName
        }`,
        phoneNumber,
        this.state.emailAddress != undefined
          ? this.state.emailAddress
          : phoneNumber,
        this.state.noOfPeople != undefined ? this.state.noOfPeople : "1",

        `${
          this.state.documentType !== null
            ? this.state.documentType + "%2D"
            : ""
        }${
          this.state.additionalInfo !== undefined
            ? this.state.additionalInfo
            : ""
        }`
      );
      if (
        issueTicketResponse.data.error !== undefined &&
        issueTicketResponse.data.error !== true
      ) {
        handler.showErrorMessage(
          this.state.lang.Error,
          this.state.lang.ServerNotResponding,
          this.state.lang.Ok
        );
      } else {
        console.log("RESPONSE OF ISSUE TICKET: ", issueTicketResponse);
        if (
          issueTicketResponse.data.ticket_info !== undefined &&
          issueTicketResponse.data.ticket_info !== null
        ) {
          const current = this.state.current + 1;

          this.setState({
            dataLoaded: true,
            response: issueTicketResponse,
            current,
          });
          console.log("STATE ON ISSUE TICKET", this.state);
        } else if (issueTicketResponse.data.resp_status === "-1") {
          this.setState({ dataLoaded: true });

          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.TicketNotIssued,
            this.state.lang.Ok
          );
        } else if (
          issueTicketResponse.data.resp_message ===
          "You already have an issued ticket for the category, in the branch."
        ) {
          this.setState({ dataLoaded: true });

          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.TicketAlreadyIssued,
            this.state.lang.Ok
          );
        }
      }
      console.log(this.state.time, "here time");

      // this.setState({ dataLoaded: true });
    } catch (error) {
      this.setState({ dataLoaded: true });
      if (error.message.includes("404")) {
        handler.showErrorMessage(
          this.state.lang.Error,
          this.state.lang.UrlNotFound,
          this.state.lang.Ok
        );
      } else if (error.message.includes("Network Error")) {
        handler.showErrorMessage(
          this.state.lang.Error,
          this.state.lang.InternetConnectionError,
          this.state.lang.Ok
        );
      } else if (error.message.includes("timeout")) {
        handler.showErrorMessage(
          this.state.lang.Error,
          this.state.lang.ServerNotResponding,
          this.state.lang.Ok
        );
      }
      console.log("ERROR IN ISSUE TICKET WITH CATEGORY SELECTION", error);
    }
  };

  issueQRTicket = async () => {
    try {
      let phoneNumber =
        this.state.phoneNumber != undefined
          ? this.state.phoneNumber.replace("+", "%2b")
          : "";
      let qrIssueTicketResponse = await this.dataService.issueTicketQR(
        this.queryBranchId,
        this.querySQN,
        "W",
        this.state.isAssistanceChecked ? this.priority : "-1",
        this.state.firstName != undefined ? this.state.firstName : "", //p1
        phoneNumber, //p2
        this.state.emailAddress != undefined ? this.state.emailAddress : "", //p3
        this.state.noOfPeople != undefined ? this.state.noOfPeople : "1", //p4
        "-", //p5
        localStorage.getItem("lang") === "es" //p6
          ? "Sp"
          : localStorage.getItem("lang"),
        `${
          this.state.documentType !== null
            ? this.state.documentType + "%2D"
            : ""
        }${
          this.state.additionalInfo !== undefined
            ? this.state.additionalInfo
            : ""
        } `, //p7
        "", //p8
        "", //p9
        "" //p10
      );
      if (
        qrIssueTicketResponse.data.error !== undefined &&
        qrIssueTicketResponse.data.error !== true
      ) {
        handler.showErrorMessage(
          this.state.lang.Error,
          this.state.lang.ServerNotResponding,
          this.state.lang.Ok
        );
      } else {
        let response = JSON.parse(qrIssueTicketResponse.data);
        let parsedResponse = JSON.parse(response[0].ResponseData);
        parsedResponse["MessageText"] = response[0].MessageText;
        parsedResponse["IsTicketCalled"] = response[0].IsTicketCalled;
        console.log("PARSED RESPONSE: ", response);
        let timestamp = parsedResponse["data"].category_approx_waittime;
        console.log("Timestamp: ", timestamp);
        var hours = Math.floor(timestamp / 60 / 60);
        var minutes = Math.floor(timestamp / 60) - hours * 60;

        console.log("PARSED RESPONSE: ", parsedResponse);

        if (parseInt(hours) < 0 || parseInt(hours) === 0) {
          hours = "00";
        }
        if (parseInt(minutes) < 0 || parseInt(minutes) === 0) {
          minutes = "00";
        }

        if (hours.toString().length === 1) {
          hours = `0${hours}`;
        }

        if (minutes.toString().length === 1) {
          minutes = `0${minutes}`;
        }

        var formatted = hours + ":" + minutes;

        parsedResponse["data"]["category_approx_waittime"] = formatted;
        if (parsedResponse.status === "Success") {
          const current = this.state.current + 1;
          this.setState({
            dataLoaded: true,
            response: parsedResponse,
            current,
          });
        } else {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.SomeThingWentWrong,
            this.state.lang.Ok
          );
          this.setState({
            dataLoaded: true,
          });
        }
      }
    } catch (error) {
      handler.showErrorMessage(
        this.state.lang.Error,
        this.state.lang.SomeThingWentWrong,
        this.state.lang.Ok
      );
      this.setState({
        dataLoaded: true,
      });
      console.log("ERROR IN QR Issue Ticket", error.message);
    }
  };

  apiCallForSamsung = async () => {
    this.setState({ dataLoaded: false });
    if (this.state.isConfirmedReschedule === true) {
      try {
        let response = await this.dataService.rescheduleAppointment(
          this.state.response.data.previous_appointment_info === null
            ? this.state.response.data.issueAppointment.appointment_number
            : this.state.response.data.previous_appointment_info
                .appointment_number,
          this.state.response.data.previous_appointment_info === null
            ? this.state.categoryId
            : this.state.response.data.previous_appointment_info.category_id,
          this.state.categoryId,
          this.state.singleBranchDetails[0].BranchID,
          this.state.singleBranchDetails[0].BranchTitle,
          this.state.singleBranchDetails[0].Address,
          this.state.singleBranchDetails[0].ContactNo,
          this.state.slotId,
          2,
          moment(this.state.date, "DD-MMM-YYYY").format("YYYY-MM-DD"),
          this.state.emailAddress,
          1,
          0,
          [
            {
              fieldName: "EmailId",
              fieldValue:
                this.state.emailAddress != undefined
                  ? this.state.emailAddress
                  : this.state.phoneNumber !== undefined
                  ? this.state.phoneNumber
                  : "",
            },
            {
              fieldName: "MobileNumber",
              fieldValue:
                this.state.phoneNumber !== undefined
                  ? this.state.phoneNumber
                  : "",
            },
            { fieldName: "PhoneModel", fieldValue: this.state.model },
            { fieldName: "PhoneColor", fieldValue: this.state.color },
            {
              fieldName: "PhoneService",
              fieldValue: this.state.phoneServiceName,
            },
            { fieldName: "IMEINumber", fieldValue: this.state.imei },
            {
              fieldName: "DeviceHealth",
              fieldValue: this.state.deviceHealth,
            },
            {
              fieldName: "FirstName",
              fieldValue:
                this.state.firstName !== undefined ? this.state.firstName : "",
            },
            {
              fieldName: "Surname",
              fieldValue:
                this.state.surName !== undefined ? this.state.surName : "",
            },
            {
              fieldName: "AppUrl",
              fieldValue: `${
                handler.urls.MODIFY_APPOINTMENT
              }${localStorage.getItem("lang")}`,
            },
            {
              fieldName: "ProductType",
              fieldValue:
                this.state.productType !== undefined
                  ? this.state.productType
                  : "",
            },
            {
              fieldName: "ProductFamily",
              fieldValue:
                this.state.productFamily !== undefined
                  ? this.state.productFamily
                  : "",
            },
          ],
          localStorage.getItem("lang") === "es"
            ? "Sp"
            : localStorage.getItem("lang"),
          this.state.time
        );
        console.log("SAMSUNG RESCHEDULE RESPONSE", response);
        if (response.data.error !== undefined && response.data.error === true) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.ServerNotResponding,
            this.state.lang.Ok
          );
        } else if (response.data.issueAppointment.resp_status === 1) {
          const current = this.state.current + 1;
          this.setState({ current, response: response });
        } else if (
          response.data.issueAppointment.resp_message ===
          "Appointment quota for this time slot has reached to its maximum value. Try selecting different time slot."
        ) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.TimeSlotQuotaExceed,
            this.state.lang.Ok
          );
        } else if (response.data.issueAppointment.resp_status === 6) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.AppointmentAlreadyCanceled,
            this.state.lang.Ok
          );
        } else if (response.data.issueAppointment.resp_status === 7) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.AppointmentExpired,
            this.state.lang.Ok
          );
        } else if (response.data.issueAppointment.resp_status === 3) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.CantRescheduleApptTcktIssued,
            this.state.lang.Ok
          );
        } else if (response.data.issueAppointment.resp_status === -2) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.AlreadyServed,
            this.state.lang.Ok
          );
        } else if (response.data.issueAppointment.resp_status === -3) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.ApptCanceledAutomatically,
            this.state.lang.Ok
          );
        } else if (response.data.issueAppointment.resp_status === -6) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.YouAlreadyHaveAnAppointment,
            this.state.lang.Ok
          );
        } else {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.SomeThingWentWrong,
            this.state.lang.Ok
          );
        }
      } catch (error) {
        if (error.message.includes("timeout")) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.ServerNotResponding,
            this.state.lang.Ok
          );
        } else {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.SomeThingWentWrong,
            this.state.lang.Ok
          );
        }
      }
    } else {
      try {
        var response = await this.dataService.issueAppointment(
          this.state.categoryId,
          this.state.singleBranchDetails[0].BranchID,
          this.state.singleBranchDetails[0].BranchTitle,
          this.state.singleBranchDetails[0].Address,
          this.state.singleBranchDetails[0].ContactNo,
          this.state.slotId,
          2,
          moment(this.state.date, "DD-MMM-YYYY").format("YYYY-MM-DD"),
          this.state.emailAddress,
          1,
          0,
          [
            {
              fieldName: "EmailId",
              fieldValue:
                this.state.emailAddress != undefined
                  ? this.state.emailAddress
                  : this.state.phoneNumber !== undefined
                  ? this.state.phoneNumber
                  : "",
            },
            {
              fieldName: "MobileNumber",
              fieldValue:
                this.state.phoneNumber !== undefined
                  ? this.state.phoneNumber
                  : "",
            },
            { fieldName: "PhoneModel", fieldValue: this.state.model },
            { fieldName: "PhoneColor", fieldValue: this.state.color },
            {
              fieldName: "PhoneService",
              fieldValue: this.state.phoneServiceName,
            },
            { fieldName: "IMEINumber", fieldValue: this.state.imei },
            { fieldName: "DeviceHealth", fieldValue: this.state.deviceHealth },
            {
              fieldName: "FirstName",
              fieldValue:
                this.state.firstName !== undefined ? this.state.firstName : "",
            },
            {
              fieldName: "Surname",
              fieldValue:
                this.state.surName !== undefined ? this.state.surName : "",
            },
            {
              fieldName: "AppUrl",
              fieldValue: `${`${
                handler.urls.MODIFY_APPOINTMENT
              }${localStorage.getItem("lang")}`}`,
            },
            {
              fieldName: "ProductType",
              fieldValue:
                this.state.productType !== undefined
                  ? this.state.productType
                  : "",
            },
            {
              fieldName: "ProductFamily",
              fieldValue:
                this.state.productFamily !== undefined
                  ? this.state.productFamily
                  : "",
            },
          ],
          localStorage.getItem("lang") === "es"
            ? "Sp"
            : localStorage.getItem("lang"),
          this.state.time
        );
        this.setState({ response: response, dataLoaded: true });
        console.log(
          "SAMSUNG RESPONSE OF ISSUE APPOINTMENT STATE",
          this.state.response
        );

        if (response.data.error !== undefined && response.data.error === true) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.ServerNotResponding,
            this.state.lang.Ok
          );
        } else if (response.data.issueAppointment.resp_status === -6) {
          swal(
            this.state.lang.AppointmentAlreadyExists,

            this.state.lang.YouAlreadyHaveAnAppointment,

            {
              icon: "warning",
              buttons: {
                keepPreviousOne: {
                  text: this.state.lang.KeepPrevious,
                  value: "keepPreviousOne",
                },
                reschedule: {
                  text: this.state.lang.Reschedule,
                  value: "reschedule",
                  closeModal: false,
                },
              },
            }
          ).then(async (value) => {
            var current;

            switch (value) {
              case "keepPreviousOne":
                if (
                  this.state.response.data.previous_appointment_info != null
                ) {
                  let prevResponse =
                    this.state.response.data.previous_appointment_info;
                  console.log("PREV RESPONSE ON KEEP PREVIOUS:", prevResponse);

                  current = this.state.current + 1;
                  this.setState({
                    model: prevResponse.phone_model,
                    color: prevResponse.phone_color,
                    phoneServiceName: prevResponse.phone_service,
                    imei: prevResponse.imei_number,
                    categoryId: prevResponse.category_id,
                    deviceHealth: prevResponse.device_health,
                    current,
                  });
                }
                break;

              case "reschedule":
                try {
                  let response = await this.dataService.rescheduleAppointment(
                    this.state.response.data.previous_appointment_info
                      .appointment_number,
                    this.state.response.data.previous_appointment_info
                      .category_id,
                    this.state.categoryId,
                    this.state.singleBranchDetails[0].BranchID,
                    this.state.singleBranchDetails[0].BranchTitle,
                    this.state.singleBranchDetails[0].Address,
                    this.state.singleBranchDetails[0].ContactNo,
                    this.state.slotId,
                    2,
                    moment(this.state.date, "DD-MMM-YYYY").format("YYYY-MM-DD"),
                    this.state.emailAddress,
                    1,
                    0,
                    [
                      {
                        fieldName: "EmailId",
                        fieldValue:
                          this.state.emailAddress != undefined
                            ? this.state.emailAddress
                            : this.state.phoneNumber !== undefined
                            ? this.state.phoneNumber
                            : "",
                      },
                      {
                        fieldName: "MobileNumber",
                        fieldValue:
                          this.state.phoneNumber !== undefined
                            ? this.state.phoneNumber
                            : "",
                      },
                      { fieldName: "PhoneModel", fieldValue: this.state.model },
                      { fieldName: "PhoneColor", fieldValue: this.state.color },
                      {
                        fieldName: "PhoneService",
                        fieldValue: this.state.phoneServiceName,
                      },
                      { fieldName: "IMEINumber", fieldValue: this.state.imei },
                      {
                        fieldName: "DeviceHealth",
                        fieldValue: this.state.deviceHealth,
                      },
                      {
                        fieldName: "FirstName",
                        fieldValue:
                          this.state.firstName !== undefined
                            ? this.state.firstName
                            : "",
                      },
                      {
                        fieldName: "Surname",
                        fieldValue:
                          this.state.surName !== undefined
                            ? this.state.surName
                            : "",
                      },
                      {
                        fieldName: "AppUrl",
                        fieldValue: `${
                          handler.urls.MODIFY_APPOINTMENT
                        }${localStorage.getItem("lang")}`,
                      },
                      {
                        fieldName: "ProductType",
                        fieldValue:
                          this.state.productType !== undefined
                            ? this.state.productType
                            : "",
                      },
                      {
                        fieldName: "ProductFamily",
                        fieldValue:
                          this.state.productFamily !== undefined
                            ? this.state.productFamily
                            : "",
                      },
                    ],
                    localStorage.getItem("lang") === "es"
                      ? "Sp"
                      : localStorage.getItem("lang"),
                    this.state.time
                  );
                  console.log("SAMSUNG RESCHEDULE RESPONSE", response);
                  swal.close();
                  if (
                    response.data.error !== undefined &&
                    response.data.error === true
                  ) {
                    handler.showErrorMessage(
                      this.state.lang.Error,
                      this.state.lang.ServerNotResponding,
                      this.state.lang.Ok
                    );
                  } else if (response.data.issueAppointment.resp_status === 1) {
                    const current = this.state.current + 1;
                    this.setState({ current, response: response });
                  } else if (
                    response.data.issueAppointment.resp_message ===
                    "Appointment quota for this time slot has reached to its maximum value. Try selecting different time slot."
                  ) {
                    handler.showErrorMessage(
                      this.state.lang.Error,
                      this.state.lang.TimeSlotQuotaExceed,
                      this.state.lang.Ok
                    );
                  } else if (response.data.issueAppointment.resp_status === 6) {
                    handler.showErrorMessage(
                      this.state.lang.Error,
                      this.state.lang.AppointmentAlreadyCanceled,
                      this.state.lang.Ok
                    );
                  } else if (response.data.issueAppointment.resp_status === 7) {
                    handler.showErrorMessage(
                      this.state.lang.Error,
                      this.state.lang.AppointmentExpired,
                      this.state.lang.Ok
                    );
                  } else if (response.data.issueAppointment.resp_status === 3) {
                    handler.showErrorMessage(
                      this.state.lang.Error,
                      this.state.lang.CantRescheduleApptTcktIssued,
                      this.state.lang.Ok
                    );
                  } else if (
                    response.data.issueAppointment.resp_status === -2
                  ) {
                    handler.showErrorMessage(
                      this.state.lang.Error,
                      this.state.lang.AlreadyServed,
                      this.state.lang.Ok
                    );
                  } else if (
                    response.data.issueAppointment.resp_status === -3
                  ) {
                    handler.showErrorMessage(
                      this.state.lang.Error,
                      this.state.lang.ApptCanceledAutomatically,
                      this.state.lang.Ok
                    );
                  } else if (
                    response.data.issueAppointment.resp_status === -6
                  ) {
                    handler.showErrorMessage(
                      this.state.lang.Error,
                      this.state.lang.YouAlreadyHaveAnAppointment,
                      this.state.lang.Ok
                    );
                  } else {
                    handler.showErrorMessage(
                      this.state.lang.Error,
                      this.state.lang.SomeThingWentWrong,
                      this.state.lang.Ok
                    );
                  }
                } catch (error) {
                  if (error.message.includes("timeout")) {
                    handler.showErrorMessage(
                      this.state.lang.Error,
                      this.state.lang.ServerNotResponding,
                      this.state.lang.Ok
                    );
                  } else {
                    handler.showErrorMessage(
                      this.state.lang.Error,
                      this.state.lang.SomeThingWentWrong,
                      this.state.lang.Ok
                    );
                  }
                }

                break;
              default:
            }
          });
        } else if (response.data.issueAppointment.resp_status === 1) {
          const current = this.state.current + 1;
          this.setState({ current, response: response });
        } else if (
          response.data.issueAppointment.resp_message ===
          "Appointment quota for this time slot has reached to its maximum value. Try selecting different time slot."
        ) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.TimeSlotQuotaExceed,
            this.state.lang.Ok
          );
        } else if (response.data.issueAppointment.resp_status === -1) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.InvalidFieldsCantIssue,
            this.state.lang.Ok
          );
        } else {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.SomeThingWentWrong,
            this.state.lang.Ok
          );
        }
      } catch (error) {
        if (error.message.includes("timeout")) {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.ServerNotResponding,
            this.state.lang.Ok
          );
        } else {
          handler.showErrorMessage(
            this.state.lang.Error,
            this.state.lang.SomeThingWentWrong,
            this.state.lang.Ok
          );
        }
      }
    }
  };

  genericApiCall = async () => {
    this.setState({ dataLoaded: false });
    if (this.state.isConfirmedReschedule === true) {
      this.rescheduleAppointment();
    } else if (this.state.issueTicket === true) {
      this.issueTicket();
    } else if (this.state.issueQrTicket === true) {
      if (
        this.isAdditionalValidation === true &&
        this.state.additionalInfo === this.ticketIssuePassword
      ) {
        this.issueQRTicket();
      } else if (
        this.isAdditionalValidation === true &&
        this.state.additionalInfo !== undefined &&
        this.state.additionalInfo != this.ticketIssuePassword
      ) {
        this.setState({ dataLoaded: true });

        handler.showErrorMessage(
          this.state.lang.Error,
          this.state.lang.IncorrectPasswordMsg,
          this.state.lang.Ok
        );
      } else if (
        this.state.additionalInfo === undefined &&
        this.isAdditionalValidation === true
      ) {
        this.setState({ dataLoaded: true });

        handler.showErrorMessage(
          this.state.lang.Error,
          this.state.lang.PasswordEmptyMsg,
          this.state.lang.Ok
        );
      } else if (this.isAdditionalValidation === false) {
        this.issueQRTicket();
      }
    } else {
      this.issueAppointment();
    }
  };

  next() {
    debugger;
    if (this.state.current === 3 && this.runApp.toLowerCase() === "samsung") {
      this.apiCallForSamsung();
    } else if (
      this.state.current === 2 &&
      this.runApp.toLowerCase() === "samsung"
    ) {
      this.apiCallForSamsung();
    } else if (
      this.enableCategorySelection === true &&
      this.runApp.toLowerCase() !== "samsung" &&
      this.state.current == 3
    ) {
      this.genericApiCall();
    } else if (
      this.state.current === 2 &&
      this.runApp.toLowerCase() !== "samsung" &&
      this.enableCategorySelection === false
    ) {
      this.genericApiCall();
    } else if (this.state.issueTicket === true && this.steps.length > 4) {
      //this condition for issue ticket case for not selecting slots
      const current = this.state.current + 2;
      this.setState({ current });
    } else {
      const current = this.state.current + 1;
      this.setState({ current });
    }

    console.log("CURRENT STATE", this.state);
    localStorage.setItem(
      "catid",
      this.state.categoryId !== null ? this.state.categoryId : ""
    );

    // console.log("CURRENT ", this.state.current);
    // console.log("STEPS LENGTH ", this.steps.length - 1);
  }

  prev() {
    //condition for going back to category screen from user details in case of issue ticket
    if (this.state.current === 3 && this.state.issueTicket === true) {
      const current = this.state.current - 2;
      this.setState({ current });
    } else if (this.state.current === 2 && this.state.issueTicket === true) {
      const current = this.state.current - 2;
      this.setState({ current });
    } else {
      const current = this.state.current - 1;
      this.setState({ current });
    }
  }

  renderStepsAction = () => {
    const queryStringBranchCode = queryString.parse(window.location.search);
    var queryBranchCode = queryStringBranchCode.branchCode;
    const queryStringSQN = queryString.parse(window.location.search);
    var querySQN = queryStringSQN.sqn;
    if (this.runApp.toLowerCase() === "samsung") {
      return (
        <div className="steps-action">
          {this.state.showBackBtn && this.state.current > 0 && (
            <SecondaryButton
              onClick={() => this.prev()}
              bgColor={this.nextAndBackBtnColor}
            >
              {this.state.lang.Back}
            </SecondaryButton>
          )}
          {this.state.showNextBtn &&
            this.state.current < this.steps.length - 1 && (
              <PrimaryButton
                onClick={() => (this.state.dataLoaded ? this.next() : null)}
                bgColor={this.nextAndBackBtnColor}
              >
                {this.state.dataLoaded === false ? (
                  <i className="fa fa-spinner fa-spin"></i>
                ) : null}
                &nbsp;
                {this.state.issueQrTicket === true
                  ? this.state.lang.TakeATicket
                  : this.state.lang.Next}
              </PrimaryButton>
            )}
        </div>
      );
    } else if (
      this.enableCategorySelection === false &&
      this.runApp.toLowerCase() !== "samsung"
    ) {
      return (
        <div className="steps-action">
          {this.state.showBackBtn &&
            ((this.state.current > 1 &&
              queryBranchCode !== undefined &&
              this.issueTicketFlag !== "true" && // this cond is for hiding backbutton when issue tic in url is true cat selection = false
              this.state.issueQrTicket === false) ||
              (this.state.current > 0 &&
                queryBranchCode === undefined &&
                this.state.issueQrTicket === false)) && (
              <SecondaryButton
                onClick={() => this.prev()}
                bgColor={this.nextAndBackBtnColor}
              >
                {this.state.lang.Back}
              </SecondaryButton>
            )}
          {this.state.showNextBtn &&
            this.state.current > 0 &&
            this.enableCategorySelection === false &&
            this.runApp.toLowerCase() !== "samsung" &&
            this.state.current < this.steps.length - 1 && (
              <PrimaryButton
                onClick={() => (this.state.dataLoaded ? this.next() : null)}
                bgColor={this.nextAndBackBtnColor}
              >
                {this.state.dataLoaded === false ? (
                  <i className="fa fa-spinner fa-spin"></i>
                ) : null}
                &nbsp;
                {this.state.issueQrTicket === true
                  ? this.state.lang.TakeATicket
                  : this.state.lang.Next}
              </PrimaryButton>
            )}
        </div>
      );
    } else if (
      this.enableCategorySelection === true &&
      this.runApp.toLowerCase() !== "samsung"
    ) {
      return (
        <div className="steps-action">
          {this.state.showBackBtn &&
            ((this.state.current > 1 &&
              queryBranchCode !== undefined &&
              this.state.issueQrTicket === false) ||
              (this.state.current > 0 &&
                queryBranchCode === undefined &&
                this.state.issueQrTicket === false)) && (
              <SecondaryButton
                onClick={() => this.prev()}
                bgColor={this.nextAndBackBtnColor}
              >
                {this.state.lang.Back}
              </SecondaryButton>
            )}

          {this.state.showNextBtn &&
            this.state.current > 0 &&
            this.enableCategorySelection === true &&
            this.runApp.toLowerCase() !== "samsung" &&
            this.state.current < this.steps.length - 1 && (
              <PrimaryButton
                onClick={() => (this.state.dataLoaded ? this.next() : null)}
                bgColor={this.nextAndBackBtnColor}
              >
                {this.state.dataLoaded === false ? (
                  <i className="fa fa-spinner fa-spin"></i>
                ) : null}
                &nbsp;
                {this.state.issueQrTicket === true
                  ? this.state.lang.TakeATicket
                  : this.state.lang.Next}
              </PrimaryButton>
            )}
        </div>
      );
    }
  };

  renderStepTranslations = () => {
    if (this.steps.length > 0) {
      if (this.runApp.toLowerCase() == "samsung") {
        this.steps[0]["title"] = this.state.lang.DeviceService;
        this.steps[1]["title"] = this.state.lang.StepSlots;
        this.steps[2]["title"] = this.state.lang.StepCustomerDetails;
        this.steps[3]["title"] = this.state.lang.StepComplete;
      } else if (this.enableCategorySelection === false) {
        this.steps[0]["title"] = this.state.lang.Branch;
        this.steps[1]["title"] = this.state.lang.StepSlots;
        this.steps[2]["title"] = this.state.lang.StepCustomerDetails;
        this.steps[3]["title"] = this.state.lang.StepComplete;
      } else if (this.enableCategorySelection === true) {
        this.steps[0]["title"] = this.state.lang.Branch;
        this.steps[1]["title"] = this.state.lang.Category;
        this.steps[2]["title"] = this.state.lang.StepSlots;
        this.steps[3]["title"] = this.state.lang.StepCustomerDetails;
        this.steps[4]["title"] = this.state.lang.StepComplete;
      }
    }
  };

  render() {
    this.renderStepTranslations();
    if (this.steps.length > 0) {
      if (this.state.singleBranchDetails === undefined) {
        return (
          <div className="container">
            <div className="sl__modal">
              <ModalHead
                address={
                  this.runApp === "samsung"
                    ? this.state.singleBranchDetails
                    : [this.state.selectedBranchFromMap]
                }
                heading={this.state.heading}
              />
              <div className="sl__modal--content">
                <div className="sl__modal--row">
                  <Empty description={this.state.lang.ServerNotResponding} />
                </div>
              </div>

              {this.showFooter === false ? null : <Footer />}
            </div>
          </div>
        );
      } else if (
        this.queryBranchCode !== undefined &&
        this.runApp.toLowerCase() !== "samsung" &&
        this.state.singleBranchDetails.length >= 0
      ) {
        return (
          <div className="container">
            <div className="sl__modal">
              <ModalHead
                address={
                  this.runApp === "samsung"
                    ? this.state.singleBranchDetails
                    : [this.state.selectedBranchFromMap]
                }
                heading={this.state.heading}
              />

              <Steps current={this.state.current}>
                {this.steps.map((item, i) => (
                  <Step key={i} title={item.title} />
                ))}
              </Steps>
              <div className="steps-content">
                {this.steps[this.state.current].content}
              </div>

              {this.renderStepsAction(this.state.lang)}

              {this.showFooter === false ? null : <Footer />}
            </div>
          </div>
        );
      } else if (
        this.queryBranchCode === undefined ||
        this.runApp === "samsung"
      ) {
        return (
          <div className="container">
            <div className="sl__modal">
              <ModalHead
                address={
                  this.runApp === "samsung"
                    ? this.state.singleBranchDetails
                    : [this.state.selectedBranchFromMap]
                }
                heading={this.state.heading}
              />

              <Steps current={this.state.current}>
                {this.steps.map((item, i) => (
                  <Step key={i} title={item.title} />
                ))}
              </Steps>

              <div className="steps-content">
                {this.steps[this.state.current].content}
              </div>

              {this.renderStepsAction()}

              {this.showFooter === false ? null : <Footer />}
            </div>
          </div>
        );
      } else {
        return (
          <div className="container">
            <div className="sl__modal">
              <ModalHead
                address={
                  this.runApp === "samsung"
                    ? this.state.singleBranchDetails
                    : [this.state.selectedBranchFromMap]
                }
                heading={this.state.heading}
              />

              <Loader />
              {this.showFooter === false ? null : <Footer />}
            </div>
          </div>
        );
      }
    } else {
      return <AppNotFound />;
    }
  }
}

export default withRouter(Main);
